<script setup lang="ts">
import type { File } from '~/types/api'

const props = defineProps<{
  image: File
  containImage?: boolean
}>()

const { getResourceUrl, getImageSrcSet } = useResources()
const srcset = getImageSrcSet(props.image.url)
</script>

<template>
  <div>
    <div
      class="relative inline-block h-56 bg-white after:absolute after:left-0 after:top-0 after:box-border after:block after:h-full after:w-full after:bg-[50%] after:bg-no-repeat after:opacity-0 after:transition-opacity after:content-['']"
    >
      <img
        class="left-0 top-0 block h-full w-full object-cover"
        :class="{
          '!object-contain': containImage,
        }"
        loading="lazy"
        :srcset="srcset"
        :src="getResourceUrl(image.url + '/576x576/FIT')"
        :alt="image.metaAlt ?? undefined"
        :title="image.metaTitle ?? undefined"
      />
    </div>
  </div>
</template>
